import Vue from "vue";

/**
 * 이벤트 허브로 이용함 비부모간 컨포넌트 끼리 통신가능
 */
const eventHub = new Vue();
/**
 * mixin 기본기능
 */
export default {
  data: () => ({
    eventHub: eventHub,
  }),
  methods: {
    /**
     * 기본 얼럿 메시지 노출
     * @param {string} msg
     */
    alertShow: function(msg) {
      this.$store.state.alert.display = true;
      this.$store.state.alert.msg = msg;
      setTimeout(() => {
        this.$store.state.alert.display = false;
        this.$store.state.alert.msg = "";
      }, 3000);
    },
    /**
     * 얼럿 숨김
     */
    alertHide: function() {
      this.$store.state.alert.display = false;
      this.$store.state.alert.msg = "";
    },
    /**
     * 기본 progress
     */
    defaultProgressShow: function() {
      this.$store.state.progressDisplay = true;
    },
    /**
     * 기본 progress 숨김
     */
    defaultProgressHide: function() {
      this.$store.state.progressDisplay = false;
    },
    circularProgressShow: function(html) {
      this.$store.state.circularProgress.html = html;
      this.$store.state.circularProgress.display = true;
      this.$store.state.circularProgress.value = 0;
    },
    circularProgressSetValue: function(val) {
      val = !isNaN(val) ? val : 0;
      val = val > 100 ? 100 : val;
      this.$store.state.circularProgress.value = val;
    },
    circularProgressHide: function() {
      this.$store.state.circularProgress.html = "";
      this.$store.state.circularProgress.display = false;
    },
    moveEcUserPage: function(userId) {
      let domain = `https://${this.$store.state.mallId}.cafe24.com/admin/php/shop1/c/member_admin_d_f.php?`;
      let params = `user_id=${userId}&shopNo=1&is_cti=&ord_year1=&ord_month1=&ord_day1=&ord_year2=&ord_month2=&ord_day2=&login_year1=&login_month1=&login_year2=&login_month2=&ord_period=&login_period=&ord_date_kind=order_date`;
      return domain + params;
    },
  },
};
